<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th :colspan="3" class="grey lighten-1 font-weight-bold subtitle-1">
            {{ $t($route.meta.title) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- No -->
        <tr>
          <td class="width-3">
            <strong>問題No.</strong>
          </td>
          <td colspan="2">
            <span>{{ $route.query.no }}</span>
          </td>
        </tr>
        <!-- Proble Type -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("PROBLEM_TYPE") }}</strong>
          </td>
          <td colspan="2">
            <span>{{
              probleType.find((e) => e.key == item.type_value)
                ? probleType.find((e) => e.key == item.type_value).text
                : ""
            }}</span>
          </td>
        </tr>
        <!-- Directive -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("DIRECTIVE") }}</strong>
          </td>
          <td colspan="2">
            <span class="pre-wrap">{{ formGeneral.leadSentence }}</span>
          </td>
        </tr>
        <!-- Void data all -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("LISTEN_ALL_VOICE_DATA") }}</strong>
          </td>
          <td colspan="2">
            <audio id="Audio" controls>
              <source :src="formGeneral.audio.fileUrl" type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </td>
        </tr>
        <!-- Script all -->
        <tr>
          <td class="width-3">
            <strong>台本</strong>
          </td>
          <td colspan="2">
            <span class="pre-wrap">{{ item.script }}</span>
          </td>
        </tr>
        <!-- Question 1 -->
        <tr>
          <th :colspan="3" class="grey lighten-1 font-weight-bold subtitle-1">
            {{ $t("QUESTIONS", { NUMBER: 1 }) }}
          </th>
        </tr>
        <!-- audio 1 -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("VOID_DATA") }}</strong>
          </td>
          <td colspan="2">
            <audio id="Audio" controls>
              <source
                :src="formGeneral.sub_question.question1.audio.fileUrl"
                type="audio/mp3"
              />
              Your browser does not support the audio element.
            </audio>
          </td>
        </tr>
        <!-- Script audio 1 -->
        <tr>
          <td class="width-3">
            <strong>台本</strong>
          </td>
          <td colspan="2">
            <span class="pre-wrap">{{
              formGeneral.sub_question.question1.script
            }}</span>
          </td>
        </tr>
        <!-- Answer 1 -->
        <tr>
          <td class="width-3" rowspan="2">
            <strong>{{ $t("ANSWER") }}</strong>
          </td>
          <td
            :class="
              checkAnswerCorrect(1, formGeneral.sub_question.question1)
                ? 'is--answers'
                : null
            "
          >
            <span>{{
              formGeneral.sub_question.question1.answers[0].value
            }}</span>
          </td>
          <td
            :class="
              checkAnswerCorrect(2, formGeneral.sub_question.question1)
                ? 'is--answers'
                : null
            "
          >
            <span>{{
              formGeneral.sub_question.question1.answers[1].value
            }}</span>
          </td>
        </tr>
        <tr>
          <td
            :class="
              checkAnswerCorrect(3, formGeneral.sub_question.question1)
                ? 'is--answers'
                : null
            "
          >
            <span>{{
              formGeneral.sub_question.question1.answers[2].value
            }}</span>
          </td>
          <td
            :class="
              checkAnswerCorrect(4, formGeneral.sub_question.question1)
                ? 'is--answers'
                : null
            "
          >
            <span>{{
              formGeneral.sub_question.question1.answers[3].value
            }}</span>
          </td>
        </tr>
        <!-- Question 2 -->
        <tr>
          <th :colspan="3" class="grey lighten-1 font-weight-bold subtitle-1">
            {{ $t("QUESTIONS", { NUMBER: 2 }) }}
          </th>
        </tr>
        <!-- audio 2 -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("VOID_DATA") }}</strong>
          </td>
          <td colspan="2">
            <audio id="Audio" controls>
              <source
                :src="formGeneral.sub_question.question2.audio.fileUrl"
                type="audio/mp3"
              />
              Your browser does not support the audio element.
            </audio>
          </td>
        </tr>
        <!-- Script audio 2 -->
        <tr>
          <td class="width-3">
            <strong>台本</strong>
          </td>
          <td colspan="2">
            <span class="pre-wrap">{{
              formGeneral.sub_question.question2.script
            }}</span>
          </td>
        </tr>
        <!-- Answer 2 -->
        <tr>
          <td class="width-3" rowspan="2">
            <strong>{{ $t("ANSWER") }}</strong>
          </td>
          <td
            :class="
              checkAnswerCorrect(1, formGeneral.sub_question.question2)
                ? 'is--answers'
                : null
            "
          >
            <span>{{
              formGeneral.sub_question.question2.answers[0].value
            }}</span>
          </td>
          <td
            :class="
              checkAnswerCorrect(2, formGeneral.sub_question.question2)
                ? 'is--answers'
                : null
            "
          >
            <span>{{
              formGeneral.sub_question.question2.answers[1].value
            }}</span>
          </td>
        </tr>
        <tr>
          <td
            :class="
              checkAnswerCorrect(3, formGeneral.sub_question.question2)
                ? 'is--answers'
                : null
            "
          >
            <span>{{
              formGeneral.sub_question.question2.answers[2].value
            }}</span>
          </td>
          <td
            :class="
              checkAnswerCorrect(4, formGeneral.sub_question.question2)
                ? 'is--answers'
                : null
            "
          >
            <span>{{
              formGeneral.sub_question.question2.answers[3].value
            }}</span>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
export default {
  store: ["formGeneral"],
  props: ["probleType", "item", "isValue"],
  methods: {
    checkAnswerCorrect(value, item) {
      return Boolean(item.isAnsewr == value);
    },
  },
};
</script>
<style  scoped>
tr td {
  border: 1px solid #ccc;
  border-top: none;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff !important;
}
</style>